// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: flights_enum.proto

/* eslint-disable */

export const protobufPackage = "usertracking.v3";

export enum CabinType {
  economy = "economy",
  business = "business",
  first_class = "first_class",
  premium_economy = "premium_economy",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function cabinTypeFromJSON(object: any): CabinType {
  switch (object) {
    case 0:
    case "economy":
      return CabinType.economy;
    case 1:
    case "business":
      return CabinType.business;
    case 2:
    case "first_class":
      return CabinType.first_class;
    case 3:
    case "premium_economy":
      return CabinType.premium_economy;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CabinType.UNRECOGNIZED;
  }
}

export function cabinTypeToJSON(object: CabinType): string {
  switch (object) {
    case CabinType.economy:
      return "economy";
    case CabinType.business:
      return "business";
    case CabinType.first_class:
      return "first_class";
    case CabinType.premium_economy:
      return "premium_economy";
    case CabinType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TripType {
  one_way = "one_way",
  roundtrip = "roundtrip",
  multi_destination = "multi_destination",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function tripTypeFromJSON(object: any): TripType {
  switch (object) {
    case 0:
    case "one_way":
      return TripType.one_way;
    case 1:
    case "roundtrip":
      return TripType.roundtrip;
    case 2:
    case "multi_destination":
      return TripType.multi_destination;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TripType.UNRECOGNIZED;
  }
}

export function tripTypeToJSON(object: TripType): string {
  switch (object) {
    case TripType.one_way:
      return "one_way";
    case TripType.roundtrip:
      return "roundtrip";
    case TripType.multi_destination:
      return "multi_destination";
    case TripType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SortingOption {
  best = "best",
  cheapest = "cheapest",
  most_expensive = "most_expensive",
  least_journey_duration = "least_journey_duration",
  earliest = "earliest",
  latest = "latest",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function sortingOptionFromJSON(object: any): SortingOption {
  switch (object) {
    case 0:
    case "best":
      return SortingOption.best;
    case 1:
    case "cheapest":
      return SortingOption.cheapest;
    case 2:
    case "most_expensive":
      return SortingOption.most_expensive;
    case 3:
    case "least_journey_duration":
      return SortingOption.least_journey_duration;
    case 4:
    case "earliest":
      return SortingOption.earliest;
    case 5:
    case "latest":
      return SortingOption.latest;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SortingOption.UNRECOGNIZED;
  }
}

export function sortingOptionToJSON(object: SortingOption): string {
  switch (object) {
    case SortingOption.best:
      return "best";
    case SortingOption.cheapest:
      return "cheapest";
    case SortingOption.most_expensive:
      return "most_expensive";
    case SortingOption.least_journey_duration:
      return "least_journey_duration";
    case SortingOption.earliest:
      return "earliest";
    case SortingOption.latest:
      return "latest";
    case SortingOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BackButtonSource {
  header = "header",
  device = "device",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function backButtonSourceFromJSON(object: any): BackButtonSource {
  switch (object) {
    case 0:
    case "header":
      return BackButtonSource.header;
    case 1:
    case "device":
      return BackButtonSource.device;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BackButtonSource.UNRECOGNIZED;
  }
}

export function backButtonSourceToJSON(object: BackButtonSource): string {
  switch (object) {
    case BackButtonSource.header:
      return "header";
    case BackButtonSource.device:
      return "device";
    case BackButtonSource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DepartureTime {
  all_day = "all_day",
  midnight = "midnight",
  morning = "morning",
  noon = "noon",
  night = "night",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function departureTimeFromJSON(object: any): DepartureTime {
  switch (object) {
    case 0:
    case "all_day":
      return DepartureTime.all_day;
    case 1:
    case "midnight":
      return DepartureTime.midnight;
    case 2:
    case "morning":
      return DepartureTime.morning;
    case 3:
    case "noon":
      return DepartureTime.noon;
    case 4:
    case "night":
      return DepartureTime.night;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DepartureTime.UNRECOGNIZED;
  }
}

export function departureTimeToJSON(object: DepartureTime): string {
  switch (object) {
    case DepartureTime.all_day:
      return "all_day";
    case DepartureTime.midnight:
      return "midnight";
    case DepartureTime.morning:
      return "morning";
    case DepartureTime.noon:
      return "noon";
    case DepartureTime.night:
      return "night";
    case DepartureTime.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface FieldError {
  field_name: string;
  error_message: string;
}

function createBaseFieldError(): FieldError {
  return { field_name: "", error_message: "" };
}

export const FieldError: MessageFns<FieldError> = {
  fromJSON(object: any): FieldError {
    return {
      field_name: isSet(object.field_name) ? globalThis.String(object.field_name) : "",
      error_message: isSet(object.error_message) ? globalThis.String(object.error_message) : "",
    };
  },

  toJSON(message: FieldError): unknown {
    const obj: any = {};
    if (message.field_name !== "") {
      obj.field_name = message.field_name;
    }
    if (message.error_message !== "") {
      obj.error_message = message.error_message;
    }
    return obj;
  },

  create(base?: DeepPartial<FieldError>): FieldError {
    return FieldError.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FieldError>): FieldError {
    const message = createBaseFieldError();
    message.field_name = object.field_name ?? "";
    message.error_message = object.error_message ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
